






import L from 'leaflet'
import NProgress from 'nprogress'
NProgress.configure({
  // showSpinner: false,
  parent: '#map'
})

export default {
  name: 'super-map',
  data() {
    return {
      map: {},
      loadingLayer: null,
      loadedLayer: null,
      airspaceLayer: null,
      layerOptions: {
        // noWrap: true
      },
      showLoader: false,
      layerHash: undefined,
      debounceUrl: undefined,
      marker: undefined
    }
  },
  props: [
    'width',
    'visible'
  ],
  computed: {
    layer() {
      return this.$store.state.persistent.layer
    },
    airspace() {
      return this.$store.state.persistent.airspace
    },
    colorblind() {
      return this.$store.state.persistent.colorblind
    },
    date() {
      return this.$store.getters['time/date']
    },
    run() {
      return this.$store.getters['time/run']
    },
    private() {
      return this.$store.getters['time/private'] && !this.$store.getters['auth/isContributor']
    },
    altitude() {
      return this.$store.getters['persistent/roundedAltitude']
    },
    tileUrl() {
      if (this.private) return ''
      const date = this.date
      const run = this.run
      let layer = this.layer
      if (this.layer === 'windalti') {
        layer = `wind${this.altitude}`
      } else if (this.layer === 'cfracalti') {
        layer = `cfrac${this.altitude}`
      } else if (this.layer === 'tempalti') {
        layer = `temp${this.altitude}`
      } else if (this.layer === 'walti') {
        layer = `w${this.altitude}`
      }
      let style = 'tile'
      if (!this.colorblind && !this.interpolate) {
        style = 'noip'
      } else if (this.colorblind && this.interpolate) {
        style = 'cbip'
      } else if (this.colorblind && !this.interpolate) {
        style = 'cbnn'
      }
      return `https://{s}-rasp.meteo-parapente.com/tiles/rasp.php/${run}/${date}/france/${layer}/{z}/{x}/{y}/${style}.png`
    },
    interpolate() {
      return this.$store.state.persistent.interpolate
    },
    center() {
      return this.$store.state.persistent.center || { lat: 0, lon: 0, zoom: 1 }
    },
    centerLeaflet() {
      return L.latLng([this.center.lat, this.center.lon])
    },
    syncData() {
      return this.$store.state.runtime.mapSync
    }
  },
  watch: {
    tileUrl() {
      this.updateLayer()
    },
    width() {
      window.Raven.context({
        extra: {
          watcher: 'width',
          center: JSON.stringify(this.center),
          centerLeaflet: JSON.stringify(this.centerLeaflet)
        }
      }, () => {
        // console.log('invalidateSize width')
        this.map.invalidateSize(false)
        // if (!this.map.getBounds().contains(this.centerLeaflet)) {
        // this.map.flyTo(this.centerLeaflet)
        this.map.panTo(this.centerLeaflet)
        // }
      })
    },
    visible() {
      window.Raven.context({
        extra: {
          watcher: 'visible',
          center: JSON.stringify(this.center),
          centerLeaflet: JSON.stringify(this.centerLeaflet)
        }
      }, () => {
        // console.log('toggle visible')
        this.map.invalidateSize(false)
        this.updateLayer()
      })
    },
    centerLeaflet() {
      window.Raven.context({
        extra: {
          watcher: 'centerLeaflet',
          center: JSON.stringify(this.center),
          centerLeaflet: JSON.stringify(this.centerLeaflet)
        }
      }, () => {
        this.marker.setLatLng(this.centerLeaflet)
        this.map.setZoom(this.center.zoom)
        if (!this.map.getBounds().contains(this.centerLeaflet)) {
          // this.map.flyTo(this.centerLeaflet)
          this.map.panTo(this.centerLeaflet)
        }
      })
    },
    airspace() {
      if (this.airspace && !this.map.hasLayer(this.airspaceLayer)) {
        this.map.addLayer(this.airspaceLayer)
      } else if (!this.airspace && this.map.hasLayer(this.airspaceLayer)) {
        this.map.removeLayer(this.airspaceLayer)
      }
    },
    syncData() {
      // if (this.syncData === null) return
      const currentCenter = this.map.getCenter()
      const currentLat = currentCenter.lat
      const currentLon = currentCenter.lng
      const currentZoom = this.map.getZoom()
      const latDiff = Math.abs(this.syncData.lat - currentLat)
      const lonDiff = Math.abs(this.syncData.lon - currentLon)
      if (latDiff > 0.000001 || lonDiff > 0.000001) {
        this.map.panTo(L.latLng([this.syncData.lat, this.syncData.lon]))
      }
      if (currentZoom !== this.syncData.zoom) {
        this.map.setZoom(this.syncData.zoom)
      }
    }
  },
  mounted() {
    const mapOptions = {
      center: this.centerLeaflet,
      zoom: this.center.zoom,
      attributionControl: false,
      zoomControl: false,
      fadeAnimation: false,
      zoomAnimation: false,
      markerZoomAnimation: false // bug marker qui n'apparait pas ?
    }

    const map = L.map('map', mapOptions)

    const getOptions = options => {
      return Object.assign(Object.assign({}, this.layerOptions), options)
    }

    const geoShadedLayer = L.tileLayer('https://geo-{s}.meteo-parapente.com/shaded/{z}/{x}/{y}.png', getOptions({
      zIndex: 2,
      maxNativeZoom: 11
    }))
    geoShadedLayer.addTo(map)

    const geoOsmLayer = L.tileLayer('https://geo-{s}.meteo-parapente.com/osm/{z}/{x}/{y}.png', getOptions({
      zIndex: 3,
      minZoom: 11
    }))
    geoOsmLayer.addTo(map)

    this.airspaceLayer = L.tileLayer('https://maps.openaip.net/geowebcache/service/tms/1.0.0/openaip_basemap@EPSG%3A900913@png/{z}/{x}/{y}.png', {
      zIndex: 4,
      tms: true
    })
    if (this.airspace) this.airspaceLayer.addTo(map)

    const iconOptions = L.Icon.Default.prototype.options
    iconOptions.iconUrl = 'img/marker-icon.png'
    iconOptions.iconRetinaUrl = 'img/marker-icon-2x.png'
    iconOptions.shadowUrl = 'img/marker-shadow.png'
    iconOptions.shadowRetinaUrl = 'img/marker-shadow.png'

    L.control.scale({ imperial: false }).addTo(map)

    const markerOptions = {
      draggable: true,
      icon: L.icon(iconOptions)
    }
    this.marker = L.marker(this.centerLeaflet, markerOptions).addTo(map)
    this.marker.on('dragend', event => {
      const latlng = event.target.getLatLng()
      this.$router.push({
        name: 'app',
        params: {
          lat: Math.round(latlng.lat * 10000) / 10000,
          lon: Math.round(latlng.lng * 10000) / 10000,
          zoom: this.map.getZoom()
        }
      })
    })
    map.on('click', event => {
      this.marker.setLatLng([event.latlng.lat, event.latlng.lng])
      this.$router.push({
        name: 'app',
        params: {
          lat: Math.round(event.latlng.lat * 10000) / 10000,
          lon: Math.round(event.latlng.lng * 10000) / 10000,
          zoom: event.target.getZoom()
        }
      })
    })
    map.on('zoomend', this.sync)
    map.on('moveend', this.sync)
    map.keyboard.disable()
    this.map = map
    this.updateLayer()
    this.sync()
  },
  methods: {
    sync() {
      const center = this.map.getCenter()
      const zoom = this.map.getZoom()
      this.$store.dispatch('runtime/mapSync', {
        lat: center.lat,
        lon: center.lng,
        zoom
      })
    },
    updateLayer() {
      // console.log('updateLayer')
      if (!this.visible) {
        // console.log('no update hidden')
        return
      }
      if (this.debounceUrl === this.tileUrl) {
        // console.log('debounce url')
        return
      }
      // console.log('switch')
      this.debounceUrl = this.tileUrl
      // console.log('create', this.date)
      const newLayer = L.tileLayer(this.tileUrl, this.layerOptions)
      newLayer.setZIndex(1)

      newLayer.on('loading', () => {
        this.showLoader = true
        setTimeout(() => {
          if (this.showLoader) NProgress.start()
        }, 300)
      })
      newLayer.on('load', () => {
        this.showLoader = false
        NProgress.done()
      })
      newLayer.once('load', () => {
        // console.log('loaded', this.date)
        this.loadingLayer = null
        if (this.loadedLayer !== null) {
          this.map.removeLayer(this.loadedLayer)
        }
        newLayer.setZIndex(0)
        this.loadedLayer = newLayer

        // this.map.eachLayer(layer => {
          // console.log(layer._url)
        // })
      })

      if (this.loadingLayer !== null) {
        // console.log('abort', this.loadingLayer._url)
        this.map.removeLayer(this.loadingLayer)
      }
      this.loadingLayer = newLayer

      newLayer.addTo(this.map)
    },
    vrac() {
      // flyTo [coords], zoom
      // mouseEventToLatLng
      // map.on('click', function(e) {
      // alert("Lat, Lon : " + e.latlng.lat + ", " + e.latlng.lng)
      // });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/super-map.vue